enum ImageSize {
  small = 's',
  medium = 'm',
  large = 'l',
}

export default ImageSize;
